import { io } from 'socket.io-client';

// const URL = process.env.REACT_APP_NODE_ENV || 'http://localhost:5000/v2';
const URL = 'https://server.citypharmacy.ca';

export const socket = io(URL, {
  autoConnect: false,
});
